export default "__VITE_ASSET__BQ4gThOU__"